import { getEnv } from '@repo/utils';

const LI_REPORTING_KEY = 'li-module-enabled';

export const setTargeting = (enriched?: boolean): void => {
  googletag.cmd.push(function () {
    let targeting = getEnv().liModuleEnabled ? 't0' : 't1';
    if (enriched) targeting += enriched ? '-e1' : '-e0';
    googletag.pubads().setTargeting(LI_REPORTING_KEY, targeting);
  });
};
